import React, { useState, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux';
import { formattedDate } from '../../utils/formattedDate';
import { PAYMENT_STATUS, PAYMENT_PLAN, USER_PAYMENT_TYPE } from '../../constants/common';
import { getSingleTransactionApi, refundAmountApi } from '../../api/usersApi';

import dummyFounder from '../../assets/images/dummyFounder.png'

const EditTransaction = ({ setEditTransaction, ref, selectedTransaction, isEditTransaction, transactionApi, setTransactionList, setNotificationMessage, setShowNotification }) => {
    const [amount, setAmount] = useState('')
    const [reason, setReason] = useState('')
    const [signleTransactionData, setSingleTransactionData] = useState([])
    const [isLoadingData, setIsLoadingData] = useState(true);
    const [isRefundLoading, setIsRefundLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState({
        amount: '',
        reason: ''
    })

    const paymentStatus = PAYMENT_STATUS;
    const userPlan = PAYMENT_PLAN;
    const paymentType = USER_PAYMENT_TYPE;

    const statusLabel = paymentStatus?.find((item) => item?.key === signleTransactionData?.status)?.value;
    const planLabel = userPlan?.find((item) => item?.key === selectedTransaction?.plan)?.value;
    const typeLabel = paymentType?.find((item) => item?.key === selectedTransaction?.userType)?.value;

    const LazyImage = ({ src, alt }) => {
        const [isVisible, setIsVisible] = useState(false);
        const imgRef = useRef();

        useEffect(() => {
            const observer = new IntersectionObserver(
                ([entry]) => {
                    if (entry.isIntersecting) {
                        setIsVisible(true);
                        observer.disconnect();
                    }
                },
                { threshold: 0.1 }
            );

            if (imgRef.current) {
                observer.observe(imgRef.current);
            }

            return () => {
                if (imgRef.current) {
                    observer.unobserve(imgRef.current);
                }
            };
        }, []);

        return (
            <img
                ref={imgRef}
                src={src}
                alt={alt}
                loading="lazy"
            />
        );
    };

    useEffect(() => {
        if (selectedTransaction?.id) {
            const fetchData = async () => {
                try {
                    setIsLoadingData(true);
                    const res = await getSingleTransactionApi(selectedTransaction?.id);
                    if (res) {
                        setSingleTransactionData(res);
                    }
                } catch (error) {
                    console.log(error);
                    setIsLoadingData(false);
                }
            }
            fetchData();
        }
    }, [selectedTransaction?.id])

    useEffect(() => {
        if (signleTransactionData && signleTransactionData !== undefined) {
            setTimeout(() => {
                setIsLoadingData(false);
            }, 3000);
        }
    }, [signleTransactionData]);

    useEffect(() => {
        if (isEditTransaction === true) {
            setAmount('');
            setReason('');
            setErrorMessage({
                amount: '',
                reason: ''
            });
        }
    }, [isEditTransaction])

    const refundAmount = async () => {
        let success = false;
        setIsRefundLoading(false);
        try {
            setIsRefundLoading(true);
            success = await refundAmountApi({
                userId: selectedTransaction?.userId,
                paymentId: selectedTransaction?.id,
                reason
            });
            if (success) {
                const data = await transactionApi();
                if (data) {
                    setTransactionList(data?.list)
                    setEditTransaction(false);
                    setShowNotification(true);
                    setNotificationMessage(`A refund of $${amount} has been issued to ${selectedTransaction?.userName}.`)
                    setTimeout(() => {
                        setShowNotification(false)
                    }, 8000)
                    setIsRefundLoading(false);
                }
            }
        } catch (error) {
            console.log(error)
            setIsRefundLoading(false);
            return false;
        }
    }

    const handleRefund = async () => {
        let isValid = true;

        const newErrors = {
            amount: '',
            reason: ''
        };

        if (!amount?.trim()) {
            newErrors.amount = 'Please enter amount for refund.';
            isValid = false;
        }

        if (!reason?.trim()) {
            newErrors.reason = 'Please enter reason for refund.';
            isValid = false;
        }

        setErrorMessage(newErrors);
        if (!isValid) return;

        const data = await refundAmount();
    }

    return (
        <>
            <div className={`${isEditTransaction && 'popup-overlay'}`}></div>
            <div className={`transaction-profile-popup ${isEditTransaction ? 'show' : ''}`} ref={ref}>
                <div className='popup-box'>
                    <div className="popup-close" onClick={() => { setEditTransaction(false) }}>
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13 1L1 13M1 1L13 13" stroke="#05171A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                    <div
                        className={`pagesTable dataTable-list ${isLoadingData ? 'loading-list profile-data-loader' : ''
                            }`}
                    >
                        <div className='transaction-basic-info'>
                            <div className="transaction-number">
                                Payment #{signleTransactionData?.id}
                                <span className={`transaction-type transaction-status ${statusLabel}`}>{statusLabel}</span>
                            </div>
                            <div className='transaction-date'>{formattedDate(signleTransactionData?.createdAt)}</div>
                            <div className="user-details">
                                <div className="reported">
                                    <span className='label'>User</span>
                                    <div className="user-name">
                                        <div className='transaction-user-image'>
                                            <LazyImage
                                                src={selectedTransaction?.userPic || dummyFounder}
                                                alt="User Image"
                                            />
                                        </div>
                                        <div className='user-transaction-name'>{selectedTransaction?.userName}</div>
                                        <div className={`user-type ${typeLabel}`}>{typeLabel}</div>
                                        <div className='user-plan'>Active {`${planLabel ? `(${planLabel})` : ''}`}</div>
                                    </div>
                                </div>
                                {
                                    signleTransactionData?.status === 'refunded' &&

                                    <div className="amount-block">
                                        <span className="label">Original payment</span>
                                        <div className="original-payment">
                                            <span >Payment #{signleTransactionData?.stripePaymentId}</span>
                                        </div>
                                    </div>
                                }
                                <div className="amount-block">
                                    <span className="label">
                                        {
                                            signleTransactionData?.status === 'refunded' ? 'Refund amount' : 'Amount'
                                        }
                                    </span>
                                    <div className="amount">
                                        <span >${signleTransactionData?.status === 'refund' ? signleTransactionData?.refundAmount : signleTransactionData?.amount}</span>
                                    </div>
                                </div>
                                {
                                    selectedTransaction?.status !== 'completed' &&
                                    <div className="amount-block">
                                        <span className="label">Reason</span>
                                        <div className="amount">
                                            <span >{signleTransactionData?.refundReason}</span>
                                        </div>
                                    </div>
                                }
                                <div className="stripe-block">
                                    <span className="label">Stripe</span>
                                    <div className="stripe">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M8.47154 12.2403L7.52873 13.1831C6.22699 14.4849 4.11644 14.4849 2.81469 13.1831C1.51294 11.8814 1.51294 9.77085 2.81469 8.4691L3.7575 7.52629M12.2428 8.4691L13.1856 7.52629C14.4873 6.22455 14.4873 4.114 13.1856 2.81225C11.8838 1.5105 9.77329 1.5105 8.47154 2.81225L7.52873 3.75506M5.66681 10.331L10.3335 5.66435" stroke="#05171A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                        <a href="#">Link to Stripe</a>
                                    </div>
                                </div>
                                {
                                    signleTransactionData?.status === 'completed' &&
                                    <>
                                        <div className="divider"></div>
                                        <div className='transaction-suspend-section'>
                                            <div className='title'>Issue refund</div>
                                            <div className='description'>Issue a refund to {selectedTransaction?.userName}. You can choose to process a full or partial refund - funds will be returned to their original payment method.</div>
                                        </div>
                                        <div className={`amount-transaction input-group ${amount ? 'filled' : ''} ${errorMessage?.amount && 'show-error'}`}>
                                            <input className='payment-refund-amount' type="text" id='amount' name='amount' autoComplete="off" value={amount} onChange={(e) => {
                                                setAmount(e.target.value)
                                                if (errorMessage?.amount) setErrorMessage(prev => ({ ...prev, amount: '' }));
                                            }} />
                                            <label htmlFor="amount">Amount to refund</label>
                                            <span className='amount-type'>USD</span>
                                        </div>
                                        {errorMessage?.amount && <p className="error-message">{errorMessage?.amount}</p>}

                                        <div className={`input-group ${reason ? 'filled' : ''}  ${errorMessage?.reason && 'show-error'}`}>
                                            <input type="text" id='reason' className='' name='reason' autoComplete="off" value={reason} onChange={(e) => {
                                                setReason(e.target.value);
                                                if (errorMessage?.reason) setErrorMessage(prev => ({ ...prev, reason: '' }));
                                            }} />
                                            <label htmlFor="reason">Reason to refund</label>
                                        </div>
                                        {errorMessage?.reason && <p className="error-message">{errorMessage?.reason}</p>}

                                        <div className='save-button-group'>
                                            <button
                                                className={`save-button button ${isRefundLoading ? 'btn_loading' : ''
                                                    }`}
                                                onClick={() => { handleRefund(); }}
                                            >
                                                {isRefundLoading ? (
                                                    <div className="registerLoader">
                                                        <div className="ring-loader"></div>
                                                    </div>
                                                ) : (
                                                    'Refund'
                                                )}
                                            </button>
                                        </div>

                                    </>
                                }

                                {
                                    signleTransactionData?.status === 'failed' &&
                                    <>

                                        <div className="suspending-process">
                                            <span className='label'>Suspending process</span>
                                            <div className="status-item completed process-one">
                                                <div className="status-icon">
                                                    <div className="circle checked" />
                                                </div>
                                                <div className="status-content">
                                                    <div className="status-title">Payment Issue - please update your payment method</div>
                                                    <div className="status-subtext">Email notification sent on April 12, 2024</div>
                                                </div>
                                            </div>
                                            <div className="status-item completed">
                                                <div className="status-icon">
                                                    <div className="circle checked" />
                                                </div>
                                                <div className="status-content">
                                                    <div className="status-title">Your account will be deleted soon</div>
                                                    <div className="status-subtext">Email notification sent on April 14, 2024</div>
                                                </div>
                                            </div>
                                            <div className="status-item pending">
                                                <div className="status-icon">
                                                    <div className="circle" />
                                                </div>
                                                <div className="status-content">
                                                    <div className="status-title">Your account has been suspended</div>
                                                    <div className="status-subtext">Email notification will be sent on April 17, 2024</div>
                                                </div>
                                            </div>
                                            <div className="status-item disabled">
                                                <div className="status-icon">
                                                    <div className="circle" />
                                                </div>
                                                <div className="status-content">
                                                    <div className="status-title">Account Suspension</div>
                                                    <div className="status-subtext">Account will be suspended on April 17, 2024</div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}

export default EditTransaction